import { type Operation } from '@main/entities/operation';
import { SunkenBox } from '@ewf/components/SunkenBox';
import { SuccessBadge } from '@ewf/components/StatusBadge/SuccessBadge';
import { TransactionProgress } from '@ewf/components/ModalUI/TransactionProgress';
import { CloseButton } from '@ewf/components/ModalUI/CloseButton';
import { Button } from '@ewf/components/Button';

export const TxSuccessWorker = ({
  operation,
  buttonLabel = 'Continue',
  onNext,
  onClose,
}: Props): JSX.Element => {
  return (
    <div className="w-[550px] rounded-lg border-2 border-transparent p-8 gradient-border-secondary-with-gray-90">
      <section className="relative mb-8 flex h-[40px] justify-end">
        <CloseButton onClick={onClose} />
      </section>
      <section className="mb-8 rounded-lg p-6 bg-popup-gradient">
        {operation ? <TransactionProgress operation={operation} step="success" /> : null}
        <SunkenBox className="mb-6 text-center">
          <p className="text-lg font-bold">Worker Account Created Successfully</p>
        </SunkenBox>
        <SunkenBox className="mt-8 grid place-items-center p-8">
          <SuccessBadge />
        </SunkenBox>
      </section>
      <section className="flex justify-center">
        <Button onClick={onNext}>{buttonLabel}</Button>
      </section>
    </div>
  );
};

interface Props {
  operation?: Operation;
  buttonLabel?: string;
  onNext: () => void;
  onClose: () => void;
}
